import { createContext } from "react";

import type { StoreLocatorReturnType } from "@locators/components/shared/hooks/useStoreLocator";

export const StoreLocatorContext = createContext<StoreLocatorReturnType>({} as StoreLocatorReturnType);
